module.exports = __webpack_public_path__ + "img/step3.0fef892a.png";